import React from 'react';
import {connect} from 'react-redux';

import {Field, reduxForm, change, clearSubmitErrors} from 'redux-form';
import FormField from 'components/FormField';
import Label from 'components/Label';
import ErrorBlock from 'components/ErrorBlock';
import {DropzoneField} from 'components/Fields';
import Dropzone from 'components/Dropzone';

import {clearField} from 'utils/forms';
import {uploadFile, ACCEPTED_FILE_TYPES} from 'ducks/files';
import {storeDataInModal, selectModal} from 'ducks/modals';
import {MODALS, verifyKycDocumentsUpload} from 'ducks/bookings';

import {
  signKycIdentificationDocument,
  signKycAddressDocument,
  signKycVisaDocument
} from 'sdk/bookings';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const extraActions = props.getModalExtraActions();
  const {identificationDocument, visaDocument, addressDocument} = values;
  const {kycId} = props;

  const data = {
    poid: identificationDocument,
    poa: addressDocument,
    visa: visaDocument,
    kyc: kycId
  };

  dispatch(verifyKycDocumentsUpload(data, extraActions));
};

class KycDocumentUploadForm extends React.Component<any> {
  state = {
    identificationDocument: [],
    visaDocument: [],
    addressDocument: []
  };

  startUploadingAction = () =>
    storeDataInModal({
      modalName: MODALS.KYC_DOCUMENT_UPLOAD,
      data: {
        uploading: true
      }
    });

  finishUploadingAction = () =>
    storeDataInModal({
      modalName: MODALS.KYC_DOCUMENT_UPLOAD,
      data: {
        uploading: false
      }
    });

  removeFile = name => {
    this.setState({[name]: []}, () => clearField(this, {field: name}));
    this.props.clearSubmitErrors();
  };

  onIdentificationFileDrop = files =>
    this.onFileDrop({
      fieldName: 'identificationDocument',
      files,
      signSdk: signKycIdentificationDocument
    });

  onVisaFileDrop = files =>
    this.onFileDrop({
      fieldName: 'visaDocument',
      files,
      signSdk: signKycVisaDocument
    });

  onAddressFileDrop = files =>
    this.onFileDrop({
      fieldName: 'addressDocument',
      files,
      signSdk: signKycAddressDocument
    });

  onFileDrop = ({fieldName, files, signSdk}) => {
    const storeIdentifierAction = identifier =>
      change('kycDocumentUpload', fieldName, identifier);

    const file = files[0];
    const signData = {
      filename: file.name,
      fileType: file.type,
      owner: this.props.agreementUserId
    };

    this.setState({[fieldName]: files}, () =>
      this.props.uploadFile({
        file,
        signSdk,
        signData,
        storeIdentifierAction,
        startUploadingAction: this.startUploadingAction,
        finishUploadingAction: this.finishUploadingAction
      })
    );
  };

  render() {
    const {error, uploading} = this.props;
    const {identificationDocument, visaDocument, addressDocument} = this.state;

    return (
      <form className="KycDocumentUploadForm">
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <div className="dropzoneFields">
          <FormField>
            <Label>Identification</Label>
            <Field
              className="kyc_Identification"
              name="identificationDocument"
              component={DropzoneField}
              onFileDrop={this.onIdentificationFileDrop}
              removeFile={() => this.removeFile('identificationDocument')}
              multiple={false}
              uploading={uploading}
              files={identificationDocument}
              acceptedFileTypes={ACCEPTED_FILE_TYPES}
              type={Dropzone.SMALL}
            />
          </FormField>
          <FormField>
            <Label>Address</Label>
            <Field
              className="kyc_Address"
              name="addressDocument"
              component={DropzoneField}
              onFileDrop={this.onAddressFileDrop}
              removeFile={() => this.removeFile('addressDocument')}
              multiple={false}
              uploading={uploading}
              files={addressDocument}
              acceptedFileTypes={ACCEPTED_FILE_TYPES}
              type={Dropzone.SMALL}
            />
          </FormField>
          <FormField>
            <Label>Visa</Label>
            <Field
              className="kyc_Visa"
              name="visaDocument"
              component={DropzoneField}
              onFileDrop={this.onVisaFileDrop}
              removeFile={() => this.removeFile('visaDocument')}
              multiple={false}
              uploading={uploading}
              files={visaDocument}
              acceptedFileTypes={ACCEPTED_FILE_TYPES}
              type={Dropzone.SMALL}
            />
          </FormField>
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => {
  const {data: {uploading}} = selectModal(state, MODALS.KYC_DOCUMENT_UPLOAD);
  const {data: {kyc: {agreementUser}}} = selectModal(state, MODALS.KYC);

  return {uploading, agreementUserId: agreementUser.id};
};

const mapDispatchToProps = {uploadFile, clearSubmitErrors};

const kycDocumentUploadForm = reduxForm({
  form: 'kycDocumentUpload',
  onSubmit: formSubmit,
  enableReinitialize: true
})(KycDocumentUploadForm);

export default connect(mapStateToProps, mapDispatchToProps)(
  kycDocumentUploadForm
);
